import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { DictTimezoneAction } from './dictTimezone.action';
import { initialState } from './dictTimezone.constant';

export const dictTimezoneReducer = reducerWithInitialState(initialState)
  .case(DictTimezoneAction.loadList.started, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Started,
  }))
  .case(DictTimezoneAction.loadList.done, (state, { result }) => ({
    ...state,
    list: result,
    networkStatus: NetworkStatus.Done,
  }))
  .case(DictTimezoneAction.loadList.failed, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Failed,
  }))
  .case(DictTimezoneAction.destroy, () => initialState);
